/**
 * cyber-nav.js
 *
 * Marca con la clase .is-cyber todo link del menu principal (cascade-nav)
 * cuyo nombre sea "cyber" o "sale" (palabra completa, sin importar
 * mayusculas; ej. "CYBER", "Cyber Week", "SALE"). Asi el boton se pinta de
 * rojo sin depender de la URL de la coleccion: Framondi puede cambiar el
 * destino, el submenu o el texto (cyber/sale) sin tocar el codigo.
 *
 * Para sumar otra palabra, agregarla al patron RED_LABEL_PATTERN.
 * Los estilos del rojo viven en sections/header.liquid (.is-cyber).
 */
(function () {
  'use strict';

  var LINK_SELECTOR = '.cascade-nav .cascade-nav__link';
  var RED_LABEL_PATTERN = /\b(cyber|sale)\b/i;

  function markRedLinks(root) {
    var links = (root || document).querySelectorAll(LINK_SELECTOR);
    for (var i = 0; i < links.length; i++) {
      links[i].classList.toggle('is-cyber', RED_LABEL_PATTERN.test(links[i].textContent));
    }
  }

  markRedLinks();

  // Por si el script corre antes de que exista el menu.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      markRedLinks();
    });
  }

  // Editor de temas: el header se vuelve a renderizar al editar la seccion.
  document.addEventListener('shopify:section:load', function (event) {
    markRedLinks(event.target);
  });
})();
